import React from "react";
import CaroselloStandard from "../../commons/CaroselloStandard";
import foto from "../../images/Nuoto/Individuali/IMG_8409.jpg"
import "../../styles/List.css"

import foto1 from "../../images/Nuoto/Individuali/IMG_8360.jpg"
import foto4 from "../../images/Nuoto/Individuali/IMG_8387.jpg"
import foto2 from "../../images/Nuoto/Individuali/IMG_8397.jpg"
import foto3 from "../../images/Nuoto/Individuali/IMG_8435.jpg"
import foto5 from "../../images/Nuoto/Individuali/IMG_8448.jpg"
import foto6 from "../../images/Nuoto/Individuali/IMG_8630.jpg"
import foto7 from "../../images/Nuoto/Individuali/IMG_importata.jpg"
import foto8 from "../../images/Nuoto/Individuali/IMG_importata2.jpg"

import Titolo from "../../commons/Titolo";
import ScrollToTopOnMount from "../../components/ScrollToTopOnMount";
import {useNavigate} from "react-router-dom";
import Space from "../../commons/Space";
import FrecciaIndietro from "../../commons/FrecciaIndietro";
import Carosello5Foto from "../../commons/CaroselloStandard";
import LezIndivAccordionPrezzi from "../../components/nuoto/LezIndivAccordionPrezzi";
import Spa from "../Spa";
import SpaceL from "../../commons/SpaceL";
import IndividualiAccordionPrezzi from "../../components/IndividualiNuoto/IndividualiAccordionPrezzi";
import TitoloSezioni from "../../commons/TitoloSezioni";


function LezioniIndividuali() {
    const navigate = useNavigate()
    return(
        <div>
            <ScrollToTopOnMount />
            <Titolo backgroundImage={foto} title={"Lezioni individuali"}/>
            <FrecciaIndietro indirizzo={"/piscina"} />
            <div style={{padding: "1em"}}>
            <figure className="text-center">
                <blockquote className="blockquote">
                    Lezioni da 45 minuti
                    con un istruttore dedicato a te e alle tue esigenze
                    <br/>
                    Adatto a chi vuole imparare a nuotare
                    o a perfezionare il proprio stile

                    <SpaceL/>
                    <br/>
                    <div className="justify-content-center m-auto" style={{maxWidth: "20em"}}>
                    Il pacchetti di lezioni sono da utilizzare <br/>
                        <div className="d-flex justify-content-center">
                            <ul className="text-start" style={{ listStylePosition: "inside" }}>
                                <li>10 lezioni entro 4 mesi</li>
                                <li>5 lezioni entro 2 mesi</li>
                            </ul>
                        </div>

                    </div>


                    {/*
                    <p>
                        <br/>
                    <strong>Pacchetto 10 lezioni</strong><br/>
                        280 € + iscrizione 10 € <br/>
                        2° allievo paga metà
                    </p>
                    */}
                     <br/>
                    *giorni e orari da concordare con l'istruttore

                </blockquote>
            </figure>

                <IndividualiAccordionPrezzi />
                <Space />
                {/*
                <LezIndivAccordionPrezzi />
                */}
            <br/>
                <TitoloSezioni title={"Special"} />
                <br/>
            <figure className="text-center">
                <blockquote className="blockquote d-flex flex-column align-items-center justify-content-center ">
                    <p>
                        <div className="ms-auto" style={{marginBottom: "3em"}}>
                            Il corso è dedicato a persone con fragilità che si avvicinano al mondo dell'acqua e desiderano imparare a nuotare.
                            <br/>
                            Gli istruttori specializzati valutano esigenze e abilità di ogni singolo allievo e progettano il percorso migliore da intraprendere.
                            <br/>
                        </div>
                        <div className="d-flex flex-wrap justify-content-center">
                            Le finalità del corso sono:
                            <ul className="custom-list">
                                <li>raggiungimento del benessere in acqua (acquaticità)</li>
                                <li>acquisizione delle tecniche natatorie</li>
                                <li>stimolazione della relazione con gli altri</li>
                                <li>sviluppo dell'autonomia personale</li>
                            </ul>
                        </div>
                        Abbonamenti quadrimestrali e stagionali,
                        giorni e orari da concordare con le referenti
                    </p>
                </blockquote>
            </figure>

            <Space />
                <CaroselloStandard foto1={foto1} foto2={foto2} foto3={foto3} foto4={foto4} foto5={foto5} foto6={foto6} foto7={foto7} foto8={foto8}/>
            <Space />
            </div>
        </div>
    )
}


export default LezioniIndividuali
